<template>
  <pl-dialog
    :title="'Disconnect RoundTable'"
    :size="'md'"
    :disableOutsideClick="true"
    @close="closeModal"
  >
    <div class="flex flex-col flex-grow justify-center">
      <div class="flex flex-row mx-auto items-center">
        <img
          v-if="integrationToDisconnect.provider_name !== 'Google Classroom'"
          :src="`/static/integrations/${integrationToDisconnect.provider_name}.png`"
          class="h-12 w-12"
        />
        <img v-else src="/static/google_class_round.png" class="h-12 w-12" />
        <img src="/static/pass_through.svg" class="mx-10 h-7" />
        <img
          src="/static/logos/parlay_logo.svg"
          alt="parlay-logo"
          class="h-12 w-12"
        />
      </div>
      <div class="flex flex-col mt-10 mx-auto">
        <div class="flex mb-2.5">
          <pl-checkbox v-model="removeAssignment" />
          <span
            v-if="integrationToDisconnect.provider_name === 'Google Classroom'"
          >
            Also delete the assignment from Google Classroom
          </span>
          <span v-else> Also delete the assignment from LMS integration </span>
        </div>
        <div class="flex">
          <pl-checkbox v-model="removeStudents" />
          <span>
            Also remove students from
            <span v-if="activityType === 'written'"
              >"{{ getCurrentRT.title }}"
            </span>
            <span v-else> "{{ getCurrentDiscussion.title }}"</span></span
          >
        </div>
      </div>
      <div class="flex items-center justify-center h-5">
        <div v-show="removeStudents" class="text-red-500 font-medium">
          Removing students will permanently delete all of their activity in the
          RoundTable.
        </div>
      </div>
    </div>
    <div class="mt-10 mb-5 mx-auto">
      <button
        class="px-8 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-400 font-semibold"
        @click="closeModal"
      >
        Cancel
      </button>
      <button
        class="px-8 py-2 bg-red-400 rounded cursor-pointer text-white font-semibold"
        @click="disconnectIntegrationCourse"
      >
        Disconnect
      </button>
    </div>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';
  import adminServices from 'services/admin/adminServices';
  import googleClassroomService from 'services/googleClassroom/googleClassroomServices';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        removeStudents: false,
        removeAssignment: false,
      };
    },
    props: {
      integrationToDisconnect: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getRoleInCourse',
        'getCourseLayoutFullScreenStatus',
        'getCurrentRT',
        'getCurrentDiscussion',
      ]),
      activityType() {
        if (this.$route.params.roundtableID) {
          return 'written';
        }
        if (this.$route.params.liveDiscussionID) {
          return 'verbal';
        }
        return null;
      },
      activityID() {
        return this.activityType === 'written'
          ? this.getCurrentRT.id
          : this.getCurrentDiscussion.id;
      },
      currentActivity() {
        if (this.activityType === 'written') {
          return this.getCurrentRT;
        }
        return this.getCurrentDiscussion;
      },
      courseWorkId() {
        if (this.integrationToDisconnect) {
          if (
            this.integrationToDisconnect.provider_name !== 'Google Classroom'
          ) {
            const integration = this.currentActivity.edlink_integrations.find(
              (ed) =>
                ed.provider_name.toLowerCase() ===
                this.integrationToDisconnect.provider_name.toLowerCase()
            );
            return integration ? integration.assignment_id : null;
          } else {
            if (this.$route.params.roundtableID) {
              return this.getCurrentRT.google_classroom_course_work_id;
            }
            if (this.$route.params.liveDiscussionID) {
              return this.getCurrentDiscussion.google_classroom_course_work_id;
            }
          }
        }
        return null;
      },
      integration() {
        return this.getCourseDetail.edlink_integrations.find(
          (x) => x.provider_name.toLowerCase() === this.integrationToDisconnect
        );
      },
      integrationActivity() {
        if (this.integration) {
          return this.currentActivity.edlink_integrations.find(
            (x) =>
              x.provider_name.toLowerCase() === this.integrationToDisconnect
          );
        }
      },
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      async disconnectIntegrationCourse() {
        const payload = {
          remove_students: this.removeStudents,
          remove_assignment: this.removeAssignment,
        };
        if (this.integrationToDisconnect.provider_name === 'Google Classroom') {
          await googleClassroomService
            .disconnectGoogleClassroomAssignment(
              this.getCourseDetail.id,
              this.getCourseDetail.google_classroom_integration.course_id,
              this.activityType,
              this.activityID,
              this.courseWorkId,
              payload
            )
            .then(() => {
              this.closeModal();
            })
            .then(() => {
              EventBus.$emit('integrationDisconnected');
            });
        } else {
          const integration_id = this.integrationToDisconnect.id;
          const edlink_course_id = this.integrationToDisconnect.course_id;

          await adminServices
            .disconnectSsoAssignment(
              this.getCourseDetail.id,
              integration_id,
              edlink_course_id,
              this.activityType,
              this.activityID,
              this.courseWorkId,
              payload
            )
            .then(() => {
              this.closeModal();
            })
            .then(() => {
              EventBus.$emit('integrationDisconnected');
            });
        }
      },
    },
    mounted() {},
  };
</script>

<style></style>



// WEBPACK FOOTER //
// disconnectAssignmentModal.vue?0452ccc4